import SimpleTrack from '../../../../common/types/release/simple-track';
import { Collaborator } from '../../../../services/collaborator/types/collaborator';

export const getTrackFullTitle = (track: SimpleTrack, collaborators: Collaborator[] = []) => {

  const featuring = collaborators.filter((a) => a.role === 'featuring').map((a) => a.name || a.contact);

  const result = `${ String(track.order).padStart(2, '0') } - ${ track.title }`

  if (featuring.length) {
    return `${result} (feat. ${ featuring.join(', ') })`;
  }

  return result;
}